import { useState, useMemo, useCallback } from "react";
import { ImageWithFallback } from "../components/figma/ImageWithFallback";
import Frame from "../../src/assets/Frame.png";

interface ImageCacheProps {
  src?: string;
  alt?: string;
  className?: string;
  width?: number | string;
  height?: number | string;
  loading?: "lazy" | "eager";
  fetchPriority?: "high" | "low" | "auto";
  objectFit?: string;
}

const imageCache = new Map<string, string>();

export const ImageCache: React.FC<ImageCacheProps> = ({
  src,
  alt = "",
  className = "",
  width = "100%",
  height = "100%",
  loading = "lazy",
  fetchPriority = "auto",
  objectFit = "cover",
}) => {
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  const cacheKey = useMemo(() => src || "fallback", [src]);
  const cachedSrc = useMemo(() => {
    if (imageCache.has(cacheKey)) {
      return imageCache.get(cacheKey);
    }
    return src;
  }, [cacheKey, src]);

  const handleLoad = useCallback(() => {
    setImageLoaded(true);
    if (src && !imageCache.has(cacheKey)) {
      imageCache.set(cacheKey, src);
    }
  }, [src, cacheKey]);

  const handleError = useCallback(() => {
    setImageError(true);
    setImageLoaded(true);
    if (!imageCache.has(cacheKey)) {
      imageCache.set(cacheKey, Frame);
    }
  }, [cacheKey]);

  return (
    <ImageWithFallback
      src={imageError || !src ? Frame : cachedSrc}
      alt={alt}
      className={`${className} object-${objectFit}`}
      style={{ width, height }}
      loading={loading}
      onLoad={handleLoad}
      onError={handleError}
      fetchPriority={fetchPriority}
      decoding="async"
    />
  );
};
// </xai:function_call >
// <xai:function_call name="read_file">
// <parameter name="path">apps/frontend/src/components/figma/ImageWithFallback.tsx
